module.exports = __webpack_public_path__ + "media/Video 110b.7a39a9db.mp4";